import { byTypeName, Typed } from '@InstanceFactory';
import { isRefObject } from './TypeGuard';
import Guid from '@Common/Core/Guid';

const knownSystemProperties = ['$id', '$ref', '$type', '$value', '$values'];

type RefSource = { $id?: Guid };
type RefTarget = { $ref: Guid };

class Ref {
    private readonly refId = Guid.newGuid();
    private refObject?: RefSource;
    private count = 0;

    public getRef(): RefTarget {
        this.count++;
        if (this.refObject) {
            this.refObject.$id = this.refId;
        }
        return { $ref: this.refId };
    }

    public setObject(refObject: any): RefTarget {
        if (this.count > 0) {
            refObject.$id = this.refId;
        }
        return (this.refObject = refObject);
    }
}

function knownProperties(obj: Partial<Typed>): string[] {
    const { fields = obj } = byTypeName(obj.$type) ?? {};
    return Object.keys(fields)
        .filter(k => !k.startsWith('$'))
        .concat(knownSystemProperties);
}

export function stringify(sourceRoot: any): string {
    const references = new Map<object, Ref>();
    const cloneDeepWithOmitAndRefs = _.partial(_.cloneDeepWith, _, source => {
        if (isRefObject(source) && !references.has(source)) {
            const ref = new Ref();
            references.set(source, ref);
            const cloned = _.pick(source, knownProperties(source));
            for (const property of Object.keys(cloned)) {
                cloned[property] = cloneDeepWithOmitAndRefs(source[property]);
            }
            return ref.setObject(cloned);
        }
        return references.get(source)?.getRef();
    });
    return JSON.stringify(cloneDeepWithOmitAndRefs(sourceRoot));
}
